module.exports = __webpack_public_path__ + "img/22.cc8e7f86.gif";